import React from 'react'
import cx from 'classnames'
import { Link } from 'react-router'
import isNumber from 'lodash/isNumber'

import { DataCard, OptionsMenu, Details, Dot, Title, TimeFrame, Message, LightBlueBadge } from './data-card-parts'

export default ({
  id,
  location,
  startsAt,
  groupId,
  endsAt,
  technicians,
  deleteWorkOrder,
  highlighted,
  backlog,
  servicings,
  servicingsCounts,
  permissions,
  ...rest
}) => {
  let servicingsCountPill = null

  if (backlog && servicingsCounts.hasOwnProperty('total')) {
    const areaText = servicingsCounts.total > 1 ? 'Areas' : 'Area'
    const text = `${servicingsCounts.total} ${areaText}`

    servicingsCountPill = <span className='backlog-servicings-count'>{text}</span>
  }

  let options = []

  if (!backlog) {
    options.push(
      {
        name: 'Edit',
        link: `/work-orders/${id}/details/edit`
      }
    )
  }

  if (permissions && permissions.canDestroy) {
    options.push(
      {
        name: 'Delete',
        action: deleteWorkOrder.bind(null, id)
      }
    )
  }
  
  return (
    <DataCard className={cx({ highlighted })}>
      <OptionsMenu optionItems={options} />

      <Link to={`/work-orders/${id}/details`}>
        <Details>
          <p>
            <LightBlueBadge text={id.toString()} />
            {servicingsCountPill}
          </p>
          <Title text={location.name} />
          {!backlog && <Dot />}
          {!backlog && <TimeFrame text={`${startsAt.format('h:mmA')} - ${endsAt.format('h:mmA')}`} />}
        </Details>

        {isNumber(groupId) &&
          <p className='group-id'>Group #{groupId}</p>}
        {!backlog && <Message text={`Technicians: ${technicianList(technicians)}`}>
        </Message>}
      </Link>
    </DataCard>
  )
}

function technicianList (technicians) {
  return technicians.map((technician) => technician.name).join(', ') || 'None assigned'
}



// WEBPACK FOOTER //
// ./src/components/data-card/work-order-card.js